// extracted by mini-css-extract-plugin
export default {"container":"ContentBox_container__++QSw","icon":"ContentBox_icon__eB4J8","label":"ContentBox_label__7j+fn","mobileCompact":"ContentBox_mobileCompact__Xcfvf"};